<!-- <div
  [class]="
    !(unstringData || (initialized ? displayChildComponent : true)) ? 'app__addDocument-card-wrapper pb-0' : 'app__addDocument-card-wrapper pb-0'
  "
> -->
<div [class]="!unstringData ? 'app__addDocument-card-wrapper pb-0' : 'app__addDocument-card-wrapper pb-0'">
  <div class="app__addDocument-card-top items-center">
    <div class="flex items-center gap-2">
      <p class="app__addDocument-card-title flex items-center gap-2">
        {{ attribute?.value?.title ?? attribute?.key }}
        @if(isHighPriorityAttribute && !unstringData){
        <img src="/assets/images/high-priority-flag-icon.svg" matTooltip="High Priority Item" matTooltipPosition="above" alt="High Priority Item" />
        }
      </p>
      @if (!!unstringData) {
      <button
        (click)="!isRemoveEditSaveSharing && openBalanceRegister()"
        [disabled]="isRemoveEditSaveSharing"
        class="app__small__primary--text__button flex items-center gap-1"
        [ngClass]="{ 'hover:cursor-pointer': !isRemoveEditSaveSharing, 'text-[#C1C2C5] hover:cursor-default': isRemoveEditSaveSharing }"
      >
        <span class="material-icons"> list </span>
        View Records
      </button>
      }
    </div>

    <div class="flex">
      @if(!!attribute?.value?.live_data_feed && !!attribute?.value?.api_source){
      <button
        class="app__small__primary--text__button"
        [ngClass]="{ 'hover:cursor-pointer': !isRemoveEditSaveSharing, 'text-[#C1C2C5] hover:cursor-default': isRemoveEditSaveSharing }"
        [matMenuTriggerFor]="!isRemoveEditSaveSharing ? menuItem : null"
        [disabled]="isRemoveEditSaveSharing"
      >
        Update<span class="material-icons text-xl">keyboard_arrow_down</span>
      </button>
      <mat-menu #menuItem="matMenu" yPosition="below" xPosition="before" class="popup-menu-panel w-fit">
        <button mat-menu-item disableRipple class="popup-menu-item" (click)="manageLiveDataFeed()">
          <p class="menuitem-text">
            <img src="/assets/images/discoveryVaultGroup/setting.svg" class="menuitem-icon" />
            Manage Connection
          </p>
        </button>
        <button mat-menu-item disableRipple class="popup-menu-item mr-10" (click)="openFormDialog()">
          <p class="menuitem-text">
            <img src="assets/images/form/add.svg" class="menuitem-icon" />
            Add Manually
          </p>
        </button> </mat-menu
      >} @else {
      <button class="app__addDocument-addButton" [disabled]="isRemoveEditSaveSharing" (click)="!isRemoveEditSaveSharing && openFormDialog()">
        <p
          class="app__form--attribute--add--btn"
          [ngClass]="{ 'hover:cursor-pointer': !isRemoveEditSaveSharing, 'text-[#C1C2C5] hover:cursor-default': isRemoveEditSaveSharing }"
        >
          <span class="material-icons text-xl">add</span> Update
        </p>
      </button>
      }
    </div>
  </div>
  <div [class]="!!unstringData ? 'app__addDocument-card-bottom pb-0' : 'app__addDocument-card-bottom pb-0'">
    @for ( input of attribute?.value?.inputs; track i; let i = $index; let last = $last) { @if (showInTemplate(input)) { @if(input?.key !=
    'reporting'){
    <!-- <div
      [ngClass]="{
        'border-b-0': last == true || i == attribute?.value?.inputs?.length - 1
      }"
      [class]="
        !(initialized ? displayChildComponent : true) && last
          ? 'app__addDocument-card-bottom-list flex items-center justify-between border-b-0'
          : 'app__addDocument-card-bottom-list flex items-center justify-between'
      "
    > -->
    <div
      [class]="
        !unstringData && last
          ? 'app__addDocument-card-bottom-list flex items-center justify-between'
          : 'app__addDocument-card-bottom-list flex items-center justify-between'
      "
    >
      <p class="text-sm flex items-center">
        {{ input?.title ?? '' }}
        @if(input?.toolTip){
        <span class="material-icons text-base material-symbols-outlined pl-2 cursor-pointer mt-1" [matTooltip]="input?.toolTip"> info</span>
        }
      </p>

      <b class="font-semibold text-lg my-[0.5rem]"> </b>
      <b [class]="handleStyleClassForAttributeValues(input)">
        @if(!unstringData || ((!unstringData[input?.key] && unstringData[input?.key] !=0) && input.key != 'effective_date' && input.key != 'as_of')){
        {{ getAttributeItemValue(input) }} }@else { @if(input?.type == 'Dollar Input'){
        {{ (unstringData[input?.key] > 0 ? unstringData[input?.key] : 0) | currency : 'USD' : true : '1.2-2' }}
        } @else if(input?.type == 'search'){
        {{ handleValueForSearch(unstringData[input?.key]) }}
        } @else if(input?.type == 'Numeric Input'){
        {{ unstringData[input?.key] | number : '1.2-2' }}
        } @else if(input?.type == 'Numeric Input 2'){
        {{ unstringData[input?.key] | number : '1.8-8' }}
        } @else if(input?.type == 'Percentage'){
        {{ unstringData[input?.key] + '%' }}
        } @else if(input?.type == 'Switch'){
        {{ convertSwitchBooleanValueToString(unstringData[input?.key]) }}
        } @else if(input?.key == 'effective_date' || input?.key =='as_of'|| input?.type == 'Date Selection'){
        {{ (unstringData[input?.key] ?? unstringData['effective_date'] ?? unstringData['as_of'] | date : 'MMM d yyyy') ?? '-' }}
        } @else{ {{ !!unstringData[input?.key] ? unstringData[input?.key] : '' }}
        }}
      </b>
    </div>

    }@else { @if(!!attribute?.value?.live_data_feed && !!attribute?.value?.api_source){
    <div class="app__addDocument-card-bottom-list flex items-center justify-between">
      <p class="app__centered-item text-sm leading-[21px] gap-3">
        @if(attribute?.value?.live_data_feed == 'mx_account_balance' && attribute?.value?.api_source == 'mx'){
         <!-- <div class="flex items-center gap-2">
          @if(!isDataFeedConnected() || (isDataFeedConnected() && selectedFileList?.[0]?.account_id)){ 
            <img src="assets/images/plaid_account_balance.svg" class="h-10 mb-0 w-fit" /> 
          }
          @if(!isDataFeedConnected() || (isDataFeedConnected() && selectedFileList?.[0]?.guid)){ 
          <img src="assets/images/mx_account_balance.svg" class="h-10 mb-0 w-fit" />
          }
         </div> -->
        } @else {
          <img
            [src]="
              attribute?.value?.live_data_feed == 'zillow' && attribute?.value?.api_source == 'zillow'
                ? 'assets/images/zillow-big-logo.svg'
                : attribute?.value?.live_data_feed == 'vehicle database' && attribute?.value?.api_source == 'vehicledatabase'
                ? 'assets/images/zero-mx-data.svg'
                : ''
            "
            class="h-10 mb-0 w-fit"
        />
        }
        @if(attribute?.value?.live_data_feed == 'mx_account_balance'){
        Integrations
        }@else{ Live Data Feed }
      </p>
      <div>
        <div class="w-fit flex items-center gap-3">
            @if(isDataFeedConnected()){
            <span class="bg-[#EFFFF7] py-1 px-3 border-solid border-[0.5px] border-[#1AA140] text-[10px] text-[#1AA140] font-semibold rounded"
              >Connected</span
            >
            } @else{
            <span class="bg-[#F3F2F1] py-1 px-3 border-solid border-[0.5px] border-[#939498] text-[10px] text-[#939498] font-semibold rounded"
              >Not Connected</span
            >
            @if(connectToMenuLabel == 'Connect with MX'){
            <div class="flex items-center gap-2">
              <button
                class="app__addDocument-addButton bg-[#25508E] text-white p-2 rounded-md"
                [disabled]="isRemoveEditSaveSharing"
                [ngClass]="{ 'text-[#C1C2C5] hover:cursor-default': isRemoveEditSaveSharing }"
                (click)="!isRemoveEditSaveSharing && addInstitutionThroughPlaid()"
              >
                {{ connectToMenuLabelPlaid }}
              </button>
              <button
                class="app__addDocument-addButton bg-[#25508E] text-white p-2 rounded-md"
                [disabled]="isRemoveEditSaveSharing"
                [ngClass]="{ 'text-[#C1C2C5] hover:cursor-default': isRemoveEditSaveSharing }"
                (click)="!isRemoveEditSaveSharing && addInstitution()"
              >
                {{ connectToMenuLabel }}
              </button>
            </div>
            }}
        </div>
      </div>
    </div>
    }
    <div
      [ngClass]="{
        'border-b-0': last && !isFromTemplate,
      }"
      class="app__addDocument-card-bottom-list flex items-center justify-between"
    >
      <p class="text-sm flex items-center">
        {{ input?.title ?? '' }}
        @if(input?.toolTip){
        <span class="material-icons text-base material-symbols-outlined pl-2 cursor-pointer mt-1" [matTooltip]="input?.toolTip"> info</span>
        }
      </p>

      <b class="font-semibold text-lg my-[0.5rem]"> </b>
      <b [class]="handleStyleClassForAttributeValues(input)">
        @if(!unstringData || ((!unstringData[input?.key] && unstringData[input?.key] !==0) && input.key != 'effective_date' && input.key != 'as_of')){
        {{ getAttributeItemValue(input) }} }@else { @if(input?.type == 'Dollar Input'){
        {{ (unstringData[input?.key] > 0 ? unstringData[input?.key] : 0) | currency : 'USD' : true : '1.2-2' }}
        } @else if(input?.type == 'search'){
        {{ handleValueForSearch(unstringData[input?.key]) }}
        } @else if(input?.type == 'Numeric Input'){
        {{ unstringData[input?.key] | number : '1.2-2' }}
        } @else if(input?.type == 'Numeric Input 2'){
        {{ unstringData[input?.key] | number : '1.8-8' }}
        } @else if(input?.type == 'Percentage'){
        {{ unstringData[input?.key] + '%' }}
        } @else if(input?.type == 'Switch'){
        {{ convertSwitchBooleanValueToString(unstringData[input?.key]) }}
        } @else if(input?.key == 'effective_date' || input?.key =='as_of'|| input?.type == 'Date Selection'){
        {{ (unstringData[input?.key] ?? unstringData['effective_date'] ?? unstringData['as_of'] | date : 'MMM d yyyy') ?? '-' }}
        } @else{ {{ !!unstringData[input?.key] ? unstringData[input?.key] : '' }}
        }}
      </b>
    </div>
    } } }
  </div>
  @if (!!unstringData ) {
  <!-- @if (initialized ? displayChildComponent : true) { -->
  <div class="px-4 mt-3 pb-4">
    <report-card-networth
      #reportCardNetworth
      [attribute_type]="attribute_type"
      [fromBalanceRegister]="true"
      [fromCurrentBalance]="true"
      [report]="{ name: 'History' }"
      [index]="51"
      [currentFormId]="currentFormId"
      [balanceType]="attribute?.value?.vault_form_code"
      [connected_to_institution]="connected_to_institution"
      [isRemoveEditSaveSharing]="isRemoveEditSaveSharing"
      [mode]="mode"
      [currentVaultUserId]="currentVaultUserId"
      [attribute]="attribute"
      [isBalanceTwo]="true"
      [isFromTemplate]="isFromTemplate"
      [getValueFromInput]="unstringData"
      [financialAttributes]="financialAttributes"
      (RegisterBalanceComponentEmitter)="handleRegisterBalanceComponentEmitter($event)"
      [fromAttribute]="true"
      (arrayLengthChanged)="handleArrayLengthChange($event)"
    >
    </report-card-networth>
  </div>
  <!-- }  -->
  } @if (!unstringData){
  <!-- @if (!unstringData || initialized && !displayChildComponent ){ -->
  <div class="w-full p-4">
    <div class="w-full h-[200px] bg-[#EBF0FA] rounded-[8px] flex items-center justify-center">
      <div class="flex items-center gap-3">
        <img src="assets/images/chart-2.svg" alt="No Report Data" class="w-[66px] h-[58px]" />
        <p class="text-sm m-0">No <span class="font-bold text-[#25508e]">Data</span> to show</p>
      </div>
    </div>
  </div>
  }
</div>
